import object1 from "./1.png";

export const wetWipesKissesOnBaby1 = [
  object1,
  object1,
  object1,
  object1,
  object1,
];
